export default __webpack_public_path__ + "static/media/tropicana-miyu.094196ea.png";